<div class="bloque-menu-socios">
  <!-- Imagen arriba -->
  <img class="bloque-de-bienvenida-img w-25" [src]="rutaImagen" alt="Imagen de bienvenida">

  <!-- Contenedor que crece y centra vertical/horizontal -->
  <div class="cards-contenedor">
    <div class="card-group px-5">
      <div class="card mx-5 pointer">
        <img src="../../../../../assets/images/mi-perfil.png" class="card-img-top w-50 mx-auto d-block" alt="..." />
        <div class="card-body">
          <h5 class="card-title">Mi perfil</h5>
          <p class="card-text">
            <small class="text-muted">Información personal</small>
          </p>
        </div>
      </div>
      <div class="card mx-5 pointer">
        <img src="../../../../../assets/images/carrito-icon.png" class="card-img-top w-50 mx-auto d-block" alt="..." />
        <div class="card-body">
          <h5 class="card-title">Productos</h5>
          <p class="card-text">
            <small class="text-muted">Alta baja o modificación de productos</small>
          </p>
        </div>
      </div>
      <div class="card mx-5 pointer">
        <img src="../../../../../assets/images/seguimiento.png" class="card-img-top w-50 mx-auto d-block" alt="..." />
        <div class="card-body">
          <h5 class="card-title">Seguimientos</h5>
          <p class="card-text">
            <small class="text-muted">
                Seguimiento de tratamientos
            </small>
          </p>
        </div>
      </div>
      <div class="card mx-5 pointer" (click)="irAPacientes()">
        <img src="../../../../../assets/images/icon-menu-pacientes.png" class="card-img-top w-50 mx-auto d-block" alt="..." />
        <div class="card-body">
          <h5 class="card-title">Pacientes</h5>
          <p class="card-text">
            <small class="text-muted">
                Podés visualizar el seguimiento de los pacientes
            </small>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>